export default __webpack_public_path__ + "static/media/empty_payments.9cd504fb.png";